<!--报销基本信息-->
<template>
  <div class="app-container">
    <div class="box-card">
      <div class="content-title"><span class="title-icon"></span><span class="title-details">报销基本信息</span></div>
      <div slot="content">
        <dynamic-form
          labelWidth="110px"
          :formConfig="formConfig"
          v-model="form"
          :showBtn="false"
          :showSaveBtn="isEdit"
          :disabled="!isEdit"
          ref="form"
          />
      </div>
      <folded-panel infoName="报销明细">
        <div slot="content">
          <edit-data-table
            :showNumber="editTable.showNumber"
            :head="editTable.bsPerformanceCompositionList"
            :editable="isEdit"
            :config="{ trigger: 'click', mode: 'cell',autoClearActive:false}"
            :showAdd="isEdit"
            :edit-rules="validRules"
            :border="true"
            :data.sync="tableData"
            ref="delRew"
            height=""
          >
          <template #costTypeId="{row}">
              <div v-for="item in constMoneys" :key="item.id">
                  <div v-if="row.costTypeId && row.costTypeId.toString() === item.value">{{item.label}}</div>
              </div>
            </template>
            <template #toolbar="scope">
              <span v-if="!isEdit">无</span>
              <el-popover v-if="isEdit" :ref="scope.$index + 'a'" placement="top" width="180">
                <p>确定删除本条数据吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="$refs[scope.$index + 'a'].doClose()">取消</el-button>
                  <el-button
                    :loading="delLoading"
                    type="primary"
                    size="mini"
                    @click="subDelete(scope.row.id,scope)">确定
                  </el-button>
                </div>
                <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>

                <!-- <el-button slot="reference" type="danger" icon="el-icon-delete" size="mini"/> -->
              </el-popover>
            </template>
            <!--基础资料，预算项目-->
            <template #projectBudgetId="{row}">
              <span>{{row.projectBudgetId?row.projectBudget.name:''}}</span>
            </template>
            <template #projectBudgetIdEdit="{row}">
              <data-box
                hostUrl="/projectDelivery/getChargeByProjectNum"
                :props="{label: 'budgetItemName',value: 'budgetItem'}"
                :extendParms="{projectNum:form.projectNumber.projectNumber}"
                v-model="row.projectBudgetId"
                :tableColumn="headLevels"
                :multiple="false"
                @confirm="(val)=>{row.projectBudgetId = val.id;row.chargeBalance = val.balance;row.projectBudget = val.bsProjectBudget}"
              ></data-box>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <folded-panel infoName="附件">
        <div slot="content">
          <el-upload
            v-if="isEdit"
            class="upload-demo"
            :action="actionUrl"
             :headers="uploadHeaders"
            :on-success="handleSuccess"
            :file-list="fileId"
            :show-file-list="true"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :on-preview="preview"
            style="margin:14px;">
            <el-button size="small" type="primary">附件上传</el-button>
          </el-upload>
          <div class="file-box" v-if="!isEdit">
            <div v-for="item in fileId" :key='item.id' class="file-item">
               <el-button @click="preview(item)">{{item.name}}</el-button>
               <!-- <i class="el-icon-close file-close" v-if="isEdit" @click="delFile(item,index)"></i> -->
            </div>
          </div>
        </div>
      </folded-panel>
      <div class="button">
        <el-button class="btn-cancel" v-if="isEdit" :loading="loading" @click="save(1)">保存</el-button>
        <el-button class="btn-submit" v-if="isEdit" :loading="loading" @click="submit(2)">提交</el-button>
        <el-button class="btn-cancel" @click="cancel">取消</el-button>
      </div>
        <drag-dialog :show="stepShow" :title="'审批人选择'" :width="'25%'" @close="close">
        <PersonStep :data="personStepData" @submit="submitConfirm" @close="close"></PersonStep>
      </drag-dialog>
    </div>
  </div>
</template>

<script>
  import FoldedPanel from "@/components/FoldedPanel"
  import "@/components/dynamic-form"
  import '@/components/EditDataTable'
  import DataTableMixin from '@/mixins/DataTableMixin'
  import initDict from "@/mixin/initDict";
  import DataBox from "@/components/dynamic-form/dynamic-data-box";
  import {getDocumentCode} from '@/views/utils'
  import CrudMixin from "@/mixins/CrudMixin";
  import {downLoad,delFile} from '@/api/bill/contract'
  import {add, edit,queryById} from '@/api/bill/reimburse'
  import { getToken } from "@/utils/auth";
  import DragDialog from "@/components/DragDialog"
// import { getFlowNode } from "@/api/hrApproval"
import PersonStep from "@/components/PersonStep";

  export default {
    name: "ReimburseForm",
    components: {
      FoldedPanel,
      DataBox,DragDialog,PersonStep
    },
    mixins: [DataTableMixin,initDict,CrudMixin],
    data() {
      return {
        uploadHeaders: {},
        actionUrl: `${process.env.VUE_APP_BASE_API}/attachment/masterdata/fileUpload`,
        fileList: [],
        delLoading: false,
        loading: false,
        tableData: [],
        formConfig: {
          formItemList: [
            {
              type: "input",
              key: "code",
              label: "单据编号",
              value: "",
              disabled: true,
              span: 8,
            },
            {
              type: "databox",
              key: "projectNumber",
              label: "项目编号",
              value: "",
              // disabled: true,
              span: 8,
              props: {
                label: 'projectNumber',
                value: 'id'
              },
              url: '/projectDelivery/getProjectDelivery',
              tableColumn: [
                {
                  property: "projectNumber",
                  label: "编码",
                  query: {
                    type: 'input'
                  }
                },
                {
                  property: "projectName",
                  label: "名称",
                  query: {
                    type: 'input'
                  }
                }
              ],
              extendParms: {queryFieldItem: 'id,projectNumber,projectName'},
              multiple: false,
              rules: {
                required: true, message: '不能为空', trigger: 'change'
              }
            },
            {
              span: 8,
              label: '报销金额',
              key: 'reimbursementAmount',
              type: 'input',
              // subtype: 'number',
              disabled: true,
              value: '',
              placeholder: '',
            },
            {
              label: '报销人',
              key: 'reimbursementId',
              type: 'databox',
              span: 8,
              props: {
                label: 'name',
                value: 'id'
              },
              url: '/bs-person/getList',
              tableColumn: [
                {
                  property: "code",
                  label: "编码",
                  query: {
                    type: 'input'
                  }
                },
                {
                  property: "name",
                  label: "名称",
                  query: {
                    type: 'input'
                  }
                }
              ],
              extendParms: {queryFieldItem: 'id,code,name'},
              multiple: false,
              rules: {
                required: true, message: '不能为空', trigger: 'change'
              }
            },
            {
              label: '收款人',
              key: 'collectionId',
              type: 'databox',
              span: 8,
              props: {
                label: 'name',
                value: 'id'
              },
              url: '/bs-person/getList',
              tableColumn: [
                {
                  property: "code",
                  label: "编码",
                  query: {
                    type: 'input'
                  }
                },
                {
                  property: "name",
                  label: "名称",
                  query: {
                    type: 'input'
                  }
                }
              ],
              extendParms: {queryFieldItem: 'id,code,name'},
              multiple: false,
              rules: {
                required: true, message: '不能为空', trigger: 'change'
              }
            },
            {
              span: 8,
              type: "select",
              label: "收款方式",
              value: "",
              disabled: false,
              multiple: false,
              placeholder: "请选择",
              rules: [{
                required: true,
                message: "不能为空",
                trigger: "blur"
              }
              ],
              key: "collectionWay",
              options: []
            },
            {
              span: 8,
              type: "input",
              key: "collectionAccount",
              label: "收款账号",
              disable: false,
              readonly: false,
              value: "",
              placeholder: "请输入收款账号",
              rules: [
                {
                  required: true,
                  message: "不能为空",
                  trigger: "blur"
                },
                // {
                //   min: 1,
                //   max: 8,
                //   type: "string",
                //   message: "长度在1~8个字符",
                //   trigger: "blur"
                // },
                // {
                //   pattern: "^[\\w\\u4e00-\\u9fa5-_]+$",
                //   message: "正则验证失败:^[\\w\\u4e00-\\u9fa5-_]+$",
                //   trigger: "blur"
                // }
              ]
            },
            {
              label: '银行',
              key: 'bankId',
              type: 'input',
              span: 8,
              props: {
                label: 'name',
                value: 'id'
              },
              // url: '/dynamic/listData',
              tableColumn: [
                {
                  property: "number",
                  label: "编码",
                  query: {
                    type: 'input'
                  }
                },
                {
                  property: "name",
                  label: "名称",
                  query: {
                    type: 'input'
                  }
                }
              ],
              extendParms: {queryFieldItem: 'id,number,name'},
              multiple: false,
            },
            // 附件	按钮
            // {
            //   type: "upload",
            //   key: "attachmentIds",
            //   label: "附件",
            //   uploadUrl: `${process.env.VUE_APP_BASE_API}/attachment/masterdata/fileUpload`,
            //   value: "",
            //   span: 8
            // },
            // 报销日期	日期
            {
              span: 8,
              label: '报销日期',
              key: 'reimbursementTime',
              type: 'date',
              placeholder: '请选择报销日期',
              rules: {
                required: true, message: '不能为空', trigger: 'blur'
              }
            },
            // 备注
            {
              span: 24,
              type: "input",
              key: "remark",
              label: "备注",
              disable: false,
              subtype: 'textarea',
              value: "",
              placeholder: "请输入备注",
               maxlength: 200,
            }
          ]
        },
        form: {},
        editTable: {
          showNumber: true,
          enableEdit: true,
          showAdd: true,
          bsPerformanceCompositionList: [
            {
              label: '预算项目',
              prop: 'projectBudgetId',
              editRender: {
                type: 'default',
                name: 'ElInput',
              }
            },
            {
              label: '费用类型',
              prop: 'costTypeId',
             editRender: {
                type: 'default', name: 'ElSelect',options: [],
              }
            },
            {
              label: '金额',
              prop: 'balance',
              editRender: {type: 'date', name: 'ElInput'}
            },
            {
              label: '备注',
              prop: 'remark',
              editRender: {
                type: 'textarea',
                name: 'ElInput',
              }
            }

          ],
        },
         validRules: {
            balance: [
                {pattern: /^\d+\.?(\d{1,2})?$/,message: '小数点后保留两位',trigger: "change"}
            // {
            //     validator(rule, value, callback) {
            //       const reg = /^\d+\.?(\d{1,2})?$/
            //       if (reg.test(value)) {
            //         callback();
            //       } else {
            //         callback(new Error("小数点后保留两位"));
            //       }
            //     },
            //     trigger: "change"
            //   }
              ]
          },
        isEdit: false,
        headLevels: [
          // { label: "编码", property: "code" },
          { label: "名称", property: "budgetItemName", query: { type: "input" } },
          { label: "结余金额", property: "balance" }
        ],
        validateRefNames: ['form'],
        constMoneys: [],
        fileId: [], // 文件上传
        dialogShow: false, // 提交弹窗
        dialogForm: {
        formItemList: []
        },
        personStepData: [],
        assignData: {}, // hr审批人员信息
        stepShow: false,
      }
    },
    watch: {
      tableData: {
        handler(val) {
          let sum = 0
          val.forEach(ele => {
            sum += Number(ele.balance)
          })
          this.form.reimbursementAmount = sum
        },
        deep: true
      }
    },
    created() {
       this.uploadHeaders = { Authorization: `Bearer ${getToken()}` }
      this.isEdit = this.$route.params.isEdit !== undefined ? Boolean(Number(this.$route.params.isEdit)) : true;
      this.id = this.$route.params.id;
      if (!this.id) {
        this.form.code = getDocumentCode('BX');
      } else {
        queryById(this.id).then(res => {
          if (res.code === 200) {
            const data = res.data;
            this.form = data.bizSubmitAccount;
            this.form.reimbursementId = {
              id: data.bizSubmitAccount.reimbursementId,
              name: data.bizSubmitAccount.reimbursement.name
            };
            this.form.collectionId = {
              id: data.bizSubmitAccount.collectionId,
              name: data.bizSubmitAccount.collection.name
            };
            this.form.projectNumber = {
              projectNumber: data.bizSubmitAccount.projectNumber,
              // id: data.bizSubmitAccount.
            }
            this.tableData = data.accountDetailList;
            this.fileId = data.attachmentIds;
            // this.fileList = data.attachmentIds;
          }
        });
      }
      // 收款方式
      this.getDict("money").then(res => {
        this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'collectionWay')].options = res.data;
      });
      // 费用类型
      this.getDict("cost_money").then(res => {
        this.$set(this.editTable.bsPerformanceCompositionList[1].editRender,'options',res.data)
        this.constMoneys = res.data;
      });
    },
    methods: {
      // 上传成功回调
      handleSuccess(res) {
        if (res.code === 200) {
           this.$notify({ title: "上传成功！", type: "success", duration: 1500 });
           this.fileId.push(res.data)
        }
      },
      // 下载文件
      preview(file) {
        console.log(file)
        downLoad(file.id,file.name)
      },
      beforeRemove(file, fileList) {
        // if (!this.isEdit) {
        //   return this.$notify({ title: "查看页面不能进行删除", type: "error", duration: 1500 });
        // }
        return this.$confirm(`确定移除 ${file.name}？`);
      },
      // 删除文件
      handleRemove(file, fileList) {
        delFile(file.id).then(res => {
            this.$notify({ title: "删除成功！", type: "success", duration: 1500 });
            this.fileId = fileList
        })
      },
      // 保存
      save(status) {
        this.loading =  true;
        // this.getFormData(status)
        this.pull(this.getFormData(status))
      },
      close() {
        this.stepShow = false;
    },
    submitConfirm(val) {
      // this.getFormData(2,val)
      this.loading = true
       const obj = this.getFormData(2)
      const obj2 = {}
      val.forEach(item => {
        let userList = "";
        item.assignData.forEach(ite => {
          userList = userList + (userList === "" ? ite.id : "," + ite.id);
        });
        obj2[item.key] = userList;
      });
      obj.assignData = JSON.stringify(obj2)
      obj.from = "reimbursement"
      // console.log('rjuq..',obj)
      this.pull(obj)
    },
      // 提交
      submit(status) {
         this.loading =  true;
          this._validateForm(this.validateRefNames).then((res) => {
          const obj = this.getFormData(status);
          obj.from = 'reimbursement'
          this.pull(obj)
        // getFlowNode({ from: "reimbursement", id: this.form.id }).then(res => {
        //   this.loading = false;
        //   this.personStepData = [];
        //   if (res.code === 200) {
        //       this.stepShow = true;
        //       this.personStepData = res.data;
        //   }
        //   });
      }).catch(e => { this.loading = false })
      },
      cancel() {
        this.$store.dispatch('tagsView/delView', this.$route)
        this.$router.go(-1);
      },
      // 封装表单数据
      getFormData(status) {
        this.form.reimbursementTime = new Date(this.form.reimbursementTime).getTime();
        if (this.form.reimbursementId) {
          this.form.reimbursementId = this.form.reimbursementId.id;
        }
        if (this.form.collectionId) {
          this.form.collectionId = this.form.collectionId.id;
        }
        if (this.form.projectNumber) {
           this.form.projectNumber = this.form.projectNumber.projectNumber;
        }
        this.form.billState = status;
        for (const i of this.tableData) {
          if (i.projectBudgetId) {
              i.projectBudgetId = i.projectBudgetId.budgetItem
          }
          if (i.chargeBalance && i.chargeBalance < i.balance) {
            return  this.$notify({ title: '金额不能大于结余金额!', type: 'error', duration: 2500})
          }
        }
        const obj = {};
        obj.bizSubmitAccount = this.form;
        obj.accountDetailList = this.tableData;
        obj.attachmentIds = this.fileId
        return obj;
      },
      pull(obj) {
        if (this.id) {
        edit(obj).then(res => {
           this.loading = false;
          if (res.code === 200) {
            this.$notify({ title: "操作成功！", type: "success", duration: 2500 });
             this.cancel();
          }
          }).catch(e => { this.loading = false });
        } else {
        add(obj).then(res => {
           this.loading = false;
          if (res.code === 200) {
            this.$notify({ title: "操作成功！", type: "success", duration: 2500 });
             this.cancel();
          }
        }).catch(e => { this.loading = false });
      }
    },
      // 绩效组成删除
      subDelete(id, scope) {
         this.tableData.splice(scope.$index, 1);
          this.$refs[scope.$index + 'a'].doClose()
        // if (!id) {
        //   this.$refs.delRew.deleteRows(scope.row);
        //   return
        // }
        // delForm(id).then(res => {
        //   if (res.code === 200) {
        //     this.$refs[scope.$index + 'a'].doClose()
        //     this.$notify({
        //       title: '删除成功',
        //       type: 'success',
        //       duration: 2500
        //     });
        //     this.tableData.splice(scope.$index, 1);
        //   }
        // });
      }
    }

  }
</script>

<style lang="scss" scoped>
.el-upload-list__item{
  width:30%;
}
  .app-container {
     .file-box {
      margin-top: 10px;
      display: flex;
      position: relative;
      padding: 10px;
      .file-item{
        position: relative;
        margin-right: 14px;
        .file-close{
          position: absolute;
          left: 0px;
          top: -6px;
          font-size: 14px;
        }
      }
    }
    .box-card {
      background-color: #fff;
      padding: 20px 30px 20px 30px;
      border-radius: 10px;

      .content-title {
        height: 40px;
        background-color: #e7eff6;
        padding-left: 20px;
        overflow: hidden;

        .title-icon {
          display: inline-block;
          margin-top: 8px;
          width: 6px;
          height: 24px;
          background-color: #1369a8;
          margin-right: 14px;
        }

        .title-details {
          overflow: hidden;
          line-height: 20px;
          display: inline-block;
          font-size: 14px;
          color: rgba(51, 51, 51, 1);
          font-family: SourceHanSansSC-regular;
        }
      }

      .button {
        padding-top: 20px;
        text-align: right;

        .btn-submit {
          width: 80px;
          height: 38px;
          background: #1369a8;
          color: white;
        }

        .btn-cancel {
          width: 80px;
          height: 38px;
          background: #fff;
        }
      }
    }
  }
</style>
